module.exports = '<svg width="37" height="32" viewBox="0 0 37 32"><path d="M36.087 12.309a2.28 2.28 0 0 0-1.801-.88h-6.857V2.286A2.284 2.284 0 0 0 25.143 0H11.429a2.284 2.284 0 0 0-2.286 2.286v9.143H2.286a2.28 2.28 0 0 0-1.801.88 2.283 2.283 0 0 0-.418 1.959l4.571 16a2.289 2.289 0 0 0 2.219 1.733h22.857a2.287 2.287 0 0 0 2.219-1.733l4.571-16a2.284 2.284 0 0 0-.418-1.959zM13.714 4.571h9.143v6.857h-9.143V4.571z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/basket-1.js
// module id = 996
// module chunks = 14